import App from './ConcreteElementApp';
import { bootstrapReactApp } from '../shared';

bootstrapReactApp('iConcreteElement', <App />);
